"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleDriveIntegrationSchemaProperties = exports.GoogleDriveIntegrationSchema = exports.GoogleTokenSchema = void 0;
const zod_1 = require("zod");
const base_organization_integration_1 = require("./base-organization-integration");
const schema_properties_interface_1 = require("./schema-properties-interface");
// Google OAuth Token Schema
exports.GoogleTokenSchema = zod_1.z.object({
    access_token: zod_1.z.string(),
    refresh_token: zod_1.z.string(),
    expires_in: zod_1.z.number().optional(),
    token_type: zod_1.z.string().optional(),
    scope: zod_1.z.string().optional(),
});
// Google Drive Integration Schema
exports.GoogleDriveIntegrationSchema = base_organization_integration_1.BaseOrganizationIntegrationSchema.extend({
    email: zod_1.z.string(),
    googleUserId: zod_1.z.string(),
    token: exports.GoogleTokenSchema.nullable(),
    tokenExpiresAt: zod_1.z.date().optional(),
    scopes: zod_1.z.array(zod_1.z.string()).optional(),
    driveInfo: zod_1.z
        .object({
        rootFolderId: zod_1.z.string().optional(),
        folderName: zod_1.z.string().optional(), // Name of the Practice folder
    })
        .optional(),
});
exports.GoogleDriveIntegrationSchemaProperties = {
    collectionName: "integrations",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=google-drive-integration.js.map